module.exports = __webpack_public_path__ + "Flag-340.d0dee04e42be89be1390c35995b31194.svg";